import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 4h-4v-1h4v1zm-6.95 0c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5 .92 0 1.75.26 2.49.69V3H3v14h10.55zM12 10.5L5 7V5l7 3.5L19 5v2l-7 3.5z"
}), 'UnsubscribeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/UnsubscribeSharp.js
// module id = 6993
// module chunks = 2